import { useCallback, useMemo, useState } from 'react'

import {
  BulkSelection,
  ExportCertificatesHandlers,
} from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable/hooks/useBulkActionsConfig'

const defaultSelection: BulkSelection = { type: 'manual', ids: [] }

interface BulkExportState {
  isOpen: boolean
  selection: BulkSelection
  selectedEmployeeIds: number[]
}

const initialState: BulkExportState = {
  isOpen: false,
  selection: defaultSelection,
  selectedEmployeeIds: [],
}

export const useExportCertificatesModal = () => {
  const [state, setState] = useState<BulkExportState>(initialState)

  const openForBulkExport = useCallback(
    (selection: BulkSelection, selectedEmployeeIds: number[]) => {
      setState({
        isOpen: true,
        selection,
        selectedEmployeeIds,
      })
    },
    []
  )

  const close = useCallback(() => {
    setState(initialState)
  }, [])

  const exportCertificatesHandlers: ExportCertificatesHandlers = useMemo(
    () => ({
      onBulkExport: openForBulkExport,
    }),
    [openForBulkExport]
  )

  return {
    isOpen: state.isOpen,
    selection: state.selection,
    selectedEmployeeIds: state.selectedEmployeeIds,
    close,
    exportCertificatesHandlers,
  }
}
